import React, {useEffect, useState} from 'react'
import loader from "../../../Loader/Loader";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import Loader from "../../../Loader/Loader";
import {toast} from "react-toastify";
import DashboardMenu from "../../layout/dashboardMenu";

const ViewTask = ({
                      getTaskById,
                      taskDetailsById=[],
                      match,
                      history,
                      removeTask,
                      removeTaskDetails=[]
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [remarks, setRemarks] = useState('')

    useEffect(() => {
        (async () => {
           setIsLoading(true)
           await getTaskById(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (removeTaskDetails?.status === 200) {
            toast.success(removeTaskDetails?.message)
            window.location.href="task-list/1"
        } else if (removeTaskDetails?.status !== undefined && removeTaskDetails?.status !== 200) {
            toast.error(removeTaskDetails?.message)
        }
    }, [removeTaskDetails])

    const handleRemove = async (e, id) => {
        e.preventDefault()
        if(id === ''){
            return false
        }

        if(remarks === ''){
            toast.error("Remark is required")
            return false
        }
        setIsLoading(true)
        await removeTask({id:id, remark:remarks})
        setIsLoading(false)
    }

    return (
        <>

            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Task"}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="card-body">
                                                <div className="user mt-4">
                                                    <div className="form-group row">
                                                        {taskDetailsById?.name !== undefined && taskDetailsById?.name !== '' && taskDetailsById?.name !== null &&
                                                            <div className="col-sm-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.name}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Task Type
                                                                </label>
                                                            </div>
                                                        }
                                                        {taskDetailsById?.title !== undefined && taskDetailsById?. title !== '' && taskDetailsById?.title !== null &&
                                                            <div className="col-sm-6 float-field mtk-025">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Remarks"
                                                                onChange={(e) => {
                                                                    // handleInput('description', e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                value={taskDetailsById?.title}
                                                                disabled
                                                            />
                                                            </div>
                                                        }
                                                        {taskDetailsById?.description !== undefined && taskDetailsById?.description !== '' && taskDetailsById?.description !== null &&
                                                            <div className="col-sm-6 float-field mtk-025">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Remarks"
                                                                onChange={(e) => {
                                                                    // handleInput('description', e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                value={taskDetailsById?.description}
                                                                disabled
                                                            />
                                                            </div>
                                                        }
                                                        {taskDetailsById?.task_date !== undefined && taskDetailsById?.task_date !== '' && taskDetailsById?.task_date !== null &&
                                                            <div className="col-sm-6 mtk-125 d-mtk-2 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.task_date}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Task Date
                                                                </label>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.client_name !== undefined && taskDetailsById?.client_name !== '' && taskDetailsById?.client_name !== null &&
                                                            <div className="col-sm-6 float-field d-mtk-2">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.client_name}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Account Name
                                                                </label>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.opportunity_name !== undefined && taskDetailsById?.opportunity_name !== '' && taskDetailsById?.opportunity_name !== null &&
                                                            <div className="col-sm-6 float-field d-mtk-2">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.opportunity_name}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Opportunity Type
                                                                </label>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.task_image !== undefined && taskDetailsById?.task_image !== '' && taskDetailsById?.task_image !== null &&
                                                            <div className="col-sm-6 float-field" style={{marginBottom:'20px'}}>
                                                                Image
                                                                <img src={taskDetailsById?.task_image} alt={""}/>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.remarks !== undefined && taskDetailsById?.remarks !== '' && taskDetailsById?.remarks !== null &&
                                                            <div className="col-sm-6 mtk-025 d-mtk-2 float-field d-mtk-2">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.remarks}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Remarks
                                                                </label>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.closure_image !== undefined && taskDetailsById?.closure_image !== '' && taskDetailsById?.closure_image !== null &&
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <div className="col-sm-6 mtk-075 float-field" style={{marginBottom:'20px'}}>
                                                                    Closure Image
                                                                    <img src={taskDetailsById?.closure_image}/>
                                                                </div>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.closure_date !== undefined && taskDetailsById?.closure_date !== '' && taskDetailsById?.closure_date !== null &&
                                                            <div className="col-sm-6 mtk-075 d-mtk-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.closure_date}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Closure Date
                                                                </label>
                                                            </div>
                                                        }
                                                        {parseInt(match?.params?.type) === 1 &&  taskDetailsById?.status === 'Open' &&
                                                            <>
                                                                <div className="col-sm-6 mtk-025 float-field d-mtk-2">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Remarks"
                                                                onChange={(e) => {
                                                                    setRemarks( e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required
                                                            />
                                                                </div>
                                                                <div className="col-md-12 mt-4">
                                                                    <button className="btn btn-primary btn-user btn-block submit-btn" onClick={(e) => handleRemove(e, taskDetailsById?.id)}>
                                                                        Close
                                                                    </button>
                                                                </div>
                                                            </>
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default ViewTask